import { ESCURO, TEXTO_COLORIDO_ESCURO } from "assets/coresTema";

// Chip com contorno no escuro: com as cores "main" do tema o texto some no cinza dos blocos (contraste ~1:1, ex.: o
// chip da ficha na aba Contratos). Texto branco e contorno/ícone no tom claro da cor, como nos botões com contorno
const contorno = (cor) => ({
  color: ESCURO.texto,
  borderColor: cor,
  "& .MuiChip-icon, & .MuiChip-deleteIcon": { color: cor },
});

const chip = {
  styleOverrides: {
    outlinedInfo: contorno(TEXTO_COLORIDO_ESCURO.info),
    outlinedPrimary: contorno(TEXTO_COLORIDO_ESCURO.primary),
    outlinedSecondary: contorno(ESCURO.textoSecundario),
    outlinedError: contorno(TEXTO_COLORIDO_ESCURO.error),
    outlinedSuccess: contorno(TEXTO_COLORIDO_ESCURO.success),
    outlinedWarning: contorno(TEXTO_COLORIDO_ESCURO.warning),
  },
};

export default chip;
